import { DataBean } from "../DataBean";

export class SecuritySpreadSheetProcess extends DataBean {



    public async deleteSocialSecuritySpreadSheetProcess(idSocialSecuritySpreadSheetProcess: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSocialSecuritySpreadSheetProcess_Number", [idSocialSecuritySpreadSheetProcess]);
    }

    public async addSocialSecuritySpreadSheetProcess(idSocialSecuritySpreadSheet: any, idProcess: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.SocialSecuritySpreadSheetProcess_addSocialSecuritySpreadSheetProcess_Number_Number_Number", [idSocialSecuritySpreadSheet, idProcess, idEmployee]);
    }

    public async getSocialSecuritySpreadSheetProcessCatalog(idSocialSecuritySpreadSheet: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSocialSecuritySpreadSheetProcessCatalog_Number", [idSocialSecuritySpreadSheet]);
    }

}